(() => {
  'use strict';

  const COUNT_SELECTOR = '[data-cart-drawer-count]';

  function getCountFromBubble() {
    const bubbleCount = document.querySelector(
      '#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]'
    );

    if (bubbleCount) {
      return parseInt(bubbleCount.textContent, 10) || 0;
    }

    return 0;
  }

  function updateCartDrawerCount() {
    const count = getCountFromBubble();

    document.querySelectorAll(COUNT_SELECTOR).forEach((element) => {
      element.textContent = count;
    });

    syncCartTimer(count);
  }

  function syncCartTimer(count) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const isEmpty = count === 0 || cartDrawer.classList.contains('is-empty');

    cartDrawer.querySelectorAll('.cart-timer').forEach((timer) => {
      timer.hidden = isEmpty;
    });

    cartDrawer.querySelectorAll('cart-countdown-timer, countdown-timer').forEach((timer) => {
      if (isEmpty && typeof timer.pauseTimer === 'function') {
        timer.pauseTimer();
      } else if (!isEmpty && typeof timer.playTimer === 'function') {
        timer.playTimer();
      }
    });
  }

  function bindCartCountUpdates() {
    updateCartDrawerCount();

    if (typeof subscribe === 'function') {
      subscribe('cart-update', () => {
        requestAnimationFrame(updateCartDrawerCount);
      });

      subscribe('quantity-update', () => {
        requestAnimationFrame(updateCartDrawerCount);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartCountUpdates, { once: true });
  } else {
    bindCartCountUpdates();
  }
})();
